import { render, staticRenderFns } from "./ChartItem.vue?vue&type=template&id=88346158&"
import script from "./ChartItem.vue?vue&type=script&lang=js&"
export * from "./ChartItem.vue?vue&type=script&lang=js&"
import style0 from "./ChartItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports